import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddPermissionRequest,
  CreatePermissionAttributeRequest,
  GroupedRoles,
  Permission,
  PermissionAttribute,
  RoleType,
  UpdatePermissionRequest,
  UpdateRoleForEntityRequest,
} from '@models/authorization';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PermissionService {
  constructor(private httpClient: HttpClient) {}

  private readonly url = `${environment.bffUrl}/authorization/permissions`;

  getAll(): Observable<Permission[]> {
    return this.httpClient.get<Permission[]>(this.url);
  }

  add(permission: AddPermissionRequest): Observable<Permission> {
    return this.httpClient.post<Permission>(this.url, permission);
  }

  update(id: string, permission: UpdatePermissionRequest): Observable<Permission> {
    return this.httpClient.put<Permission>(`${this.url}/${id}`, permission);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${id}`);
  }

  getPermissionRoles(id: string, type: RoleType = 'Regular'): Observable<GroupedRoles[]> {
    return this.httpClient.get<GroupedRoles[]>(`${this.url}/${id}/roles`, { params: { type } });
  }

  patchPermissionRoles(id: string, roles: UpdateRoleForEntityRequest[], type: RoleType = 'Regular'): Observable<GroupedRoles[]> {
    return this.httpClient.patch<GroupedRoles[]>(`${this.url}/${id}/roles`, roles, { params: { type } });
  }

  getPermissionAttributes(permissionId: string): Observable<PermissionAttribute[]> {
    return this.httpClient.get<PermissionAttribute[]>(`${this.url}-attributes`, {
      params: { permissionId: permissionId },
    });
  }
  getPermissionAttributeById(attributeId: string): Observable<PermissionAttribute> {
    return this.httpClient.get<PermissionAttribute>(`${this.url}-attributes/${attributeId}`);
  }

  addPermissionAttribute(attribute: CreatePermissionAttributeRequest): Observable<PermissionAttribute> {
    return this.httpClient.post<PermissionAttribute>(`${this.url}-attributes`, attribute);
  }

  deletePermissionAttribute(attributeId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}-attributes/${attributeId}`);
  }
}
